var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading()),expression:"isLoading()"}],staticClass:"bikesport-ui-loader absolute inset-0 w-full"},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute inset-0 w-full h-12 m-auto"},[_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"bounce1"}),_c('div',{staticClass:"bounce2"}),_c('div',{staticClass:"bounce3"})])])
}]

export { render, staticRenderFns }